export const INCREMENT_VIEWS = "INCREMENT_VIEWS";
export const LOAD_DATA = "LOAD_DATA_EXPLORE";
export const LOAD_POSTS = "LOAD_DATA_POSTS";
export const ADD_BY_BRAND = "ADDbyBRAND";
export const REMOVE_BY_BRAND = "DELbyBRAND";
export const ADD_BY_GENDER = "ADDbyGENDER";
export const REMOVE_BY_GENDER = "DELbyGENDER";
export const ADD_BY_TYPE = "ADDbyTYPE";
export const REMOVE_BY_TYPE = "DELbyTYPE";
export const SINGLE_BRAND = "SINGLE_BRAND";
export const SINGLE_GENDER = "SINGLE_GENDER";
export const SINGLE_TYPE = "SINGLE_TYPE";
export const LATEST = "LATEST";
export const SEARCH = "search";
export const CLEAR_ALL = "clearAll";
export const SORT = "Sort";
export const COMMENT = "COMMENT";